/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Connection,
  Connection$inboundSchema,
  Connection$Outbound,
  Connection$outboundSchema,
} from "./connection.js";
import {
  Pagination,
  Pagination$inboundSchema,
  Pagination$Outbound,
  Pagination$outboundSchema,
} from "./pagination.js";

export type ConnectionList = {
  pagination: Pagination;
  connections: Array<Connection>;
};

/** @internal */
export const ConnectionList$inboundSchema: z.ZodType<
  ConnectionList,
  z.ZodTypeDef,
  unknown
> = z.object({
  pagination: Pagination$inboundSchema,
  connections: z.array(Connection$inboundSchema),
});
/** @internal */
export type ConnectionList$Outbound = {
  pagination: Pagination$Outbound;
  connections: Array<Connection$Outbound>;
};

/** @internal */
export const ConnectionList$outboundSchema: z.ZodType<
  ConnectionList$Outbound,
  z.ZodTypeDef,
  ConnectionList
> = z.object({
  pagination: Pagination$outboundSchema,
  connections: z.array(Connection$outboundSchema),
});

export function connectionListToJSON(connectionList: ConnectionList): string {
  return JSON.stringify(ConnectionList$outboundSchema.parse(connectionList));
}
export function connectionListFromJSON(
  jsonString: string,
): SafeParseResult<ConnectionList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectionList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectionList' from JSON`,
  );
}
